// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bargainBinCategoryAccordionStyles } from "@awc/App/Components/BargainBin/BargainBinCategoryAccordion";
import CaretDownSharp from "@awc/XDL/Icons/CaretDownSharp";
import CaretRightSharp from "@awc/XDL/Icons/CaretRightSharp";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { barginBinBoxStyle, color } from "@awc/XDL/Utilities";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

bargainBinCategoryAccordionStyles.accordionSection = {
    titleTypographyProps: {
        weight: fontConfig.weight.regular,
        size: fontConfig.fontSize.singleLineRegular,
        css: css`
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.regular};
            margin-bottom: 0;
        `,
    },
    toggleTransition: {
        positionerCss: css`
            margin-top: 5px;
        `,
    },
    toggleIconProps: {
        src: CaretDownSharp,
        color: "text",
        size: 12,
    },
    expandIconProps: {
        src: CaretRightSharp,
        color: "text",
        size: 12,
    },

    headerProps: {
        css: css`
            background: ${color("common.white")};
            padding: 0;
            border: 0;
            border-top: 0;
            &:first-of-type {
                border-top: 0;
            }
            &&& button,
            &&& button:focus {
                background: transparent;
                padding: 0;
                border: none;
                ${TypographyStyle} {
                    color: ${color("text")};
                }
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
                flex-direction: row-reverse;
                column-gap: 4px;
            }

            ${({ expanded }: AccordionSectionHeaderProps) =>
                !expanded &&
                css`
                    &&& button,
                    &&& button:focus {
                        background: transparent;

                        ${TypographyStyle} {
                            color: ${color("text")};
                        }
                    }
                `}

            &:after {
                content: "";
                position: absolute;
                border-top: 1px solid ${color("common.ui32")};
                width: calc(100% - 8px);
                left: 4px;
            }
        `,
    },
    panelProps: {
        css: css`
            border: 0;
            color: ${color("text")};
            padding-left: 16px;
            font-size: ${fontConfig.fontSize.singleLineRegular};
            letter-spacing: 0;
            line-height: ${fontConfig.lineHeight.regular};
            padding: 0;
            padding-left: 16px;
        `,
    },
};
bargainBinCategoryAccordionStyles.accordion = {
    css: css`
        .product-link {
            &::after {
                content: "";
                position: absolute;
                width: calc(100% - 8px);
                left: 4px;
                height: 1px;
                background-color: ${color("common.ui32")};
            }

            &.selected::after,
            &:hover::after,
            &:focus::after {
                height: 23px;
                background-color: ${color("common.ui14")};
            }
        }

        &.level3 dd {
            padding-left: 20px;
        }
        &.level1 {
            position: relative;
            margin-bottom: 5px;
            & > dd {
                margin: 0;
                ${barginBinBoxStyle}
                padding-left: 10px;
            }

            & > dt {
                border: 0;
                padding: 9px;
                background: ${color("primary")};
                button ${TypographyStyle} {
                    color: ${color("common.white")} !important;
                }

                ${IconWrapper} {
                    color: ${color("common.white")};
                }
                &:after {
                    display: none;
                }
            }
        }
    `,
};
bargainBinCategoryAccordionStyles.productLink = {
    typographyProps: {
        weight: fontConfig.weight.regular,
        css: css`
            &:hover {
                color: ${color("primary")};
            }
        `,
    },
    css: css`
        width: 100%;
        position: relative;
        z-index: 1;
        &:hover {
            &,
            ${TypographyStyle} {
                color: ${color("primary")};
            }
        }
    `,
};
